for_list = (first_transaction_date) ->
  all_time = (if HM.is_russian then 'С начала учёта' else 'All Time')
  last = (x) -> (if HM.is_russian then "Прошлые #{x} мес" else "Last #{x} mths")
  next = (x) -> (if HM.is_russian then "Будущие #{x} мес" else "Next #{x} mths")
  [
    { text: last(3) , range: [hm_date.addMonths(new Date, -3),  hm_date.constants.today] }
    { text: last(6) , range: [hm_date.addMonths(new Date, -6),  hm_date.constants.today] }
    { text: last(12), range: [hm_date.addMonths(new Date, -12), hm_date.constants.today] }
    { text: all_time, range: [first_transaction_date, hm_date.constants.today] }
    { text: '' }
    { text: next(3) , range: [hm_date.constants.today, hm_date.addMonths(new Date,  3)] }
    { text: next(6) , range: [hm_date.constants.today, hm_date.addMonths(new Date,  6)] }
    { text: next(12), range: [hm_date.constants.today, hm_date.addMonths(new Date, 12)] }
  ]

############

for_compare_periods = (first_transaction_date) ->
  monthly_ranges = []
  for i in [0, 1, 2, 3]
    monthly_ranges.push
      key:   "month_#{i}"
      label: _.capitalize(hm_date.format(hm_date.addMonths(new Date, -i), 'MMMM'))
      start: hm_date.startOfMonth_f(hm_date.addMonths(new Date, -i))
      end:   hm_date.endOfMonth_f(hm_date.addMonths(new Date, -i))
  ranges = [{
    label: (if HM.is_russian then "По месяцам" else "Months")
    ranges: monthly_ranges
  }]

  last_ranges = _.map [3, 6, 12], (i) ->
    key: "last_#{i}_months"
    label: (if HM.is_russian then "Прошлые #{i} мес" else "Last #{i} months" )
    start: hm_date.addMonths_f(hm_date.startOfMonth(new Date), -i)
    end: hm_date.addDays_f(hm_date.startOfMonth(new Date), -1)

  last_ranges.push
    key: 'all_time'
    label: (if HM.is_russian then 'С начала учёта' else 'All Time')
    start: hm_date.startOfMonth_f(first_transaction_date)
    end: hm_date.constants.today

  ranges.push
    label: (if HM.is_russian then 'Прошлые' else 'Last')
    ranges: last_ranges

  years_ranges = []
  date = hm_date.endOfYear(new Date)
  first_transaction_date = hm_date.parse(first_transaction_date)
  while date > first_transaction_date
    years_ranges.push
      group: 'years'
      key:   hm_date.format(date, 'YYYY')
      label: hm_date.format(date, 'YYYY')
      start: hm_date.startOfYear_f(date)
      end: hm_date.endOfYear_f(date)
    date = hm_date.addMonths(date, -12)

  ranges.push
    label: (if HM.is_russian then 'По годам' else 'By years')
    ranges: years_ranges

  ranges

module.exports =
  compare_periods: for_compare_periods
  list:            for_list
